import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticLoginPage.css';
import logo from '../../shared/assets/logopng.png';
import illustration from '../../shared/assets/otp_img.png';
import { authService } from './services/authService';
import { validateMobile } from '../../shared/utils/phoneValidation';
import { useSnackbar } from '../../contexts/SnackbarContext';
import { MOBILE_BREAKPOINT, SPLASH_DURATION } from '../../shared/constants/uiConstants';
import { Link } from "react-router-dom";
import { IoMailOpenOutline } from "react-icons/io5";

const StaticLoginPage = () => {
  const [showSplash, setShowSplash] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { showSnackbar } = useSnackbar();
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const navigate = useNavigate();

  const checkMobileAndShowSplash = useCallback(() => {
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    if (isMobile) {
      setShowSplash(true);
      const timer = setTimeout(() => setShowSplash(false), SPLASH_DURATION);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    return checkMobileAndShowSplash();
  }, [checkMobileAndShowSplash]);

  // Handle OTP button click
  const handleGetOtpClick = async () => {
    if (!phoneNumber || !validateMobile(phoneNumber)) {
      showSnackbar('Please enter a valid phone number', 'error');
      return;
    }

    setIsLoading(true);
    try {
      const data = await authService.sendOTP(phoneNumber);
      if (data && data.success) {
        showSnackbar(data.data.message, 'success');
        navigate('/otp', { state: { phoneNumber } });
      } else {
        showSnackbar('Please enter the registered phone number', 'error');
      }
    } catch (error) {
      showSnackbar('Failed to verify phone number. Please try again.', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Splash Screen for Mobile */}
      {showSplash && (
        <div className="splash-screen">
          <img src={logo} alt="TykVen Logo" className="logoLogin" />
          <h1 className="app-title">TykVen Client</h1>
          <p className="app-subtitle">The Field Service Manager</p>
        </div>
      )}

      {/* Main Content */}
      {!showSplash && (
        <div className="content-wrapper">
          {/* Left Section */}
          <div className="left-section">
            <img src={logo} alt="TykVen Logo" className="logo" />
            <h1 className="app-title">TykVen Client</h1>
            <p className="app-subtitle">The Field Service Manager</p>
          </div>

          {/* Right Section */}
          <div className="right-section">
            <form
              className="login-form"
              onSubmit={(e) => e.preventDefault()} // Prevent default form submission
            >
              <img
                src={illustration}
                alt="Login Illustration"
                className="form-illustration"
              />
              <h2 className="form-title">OTP Verification</h2>
              <p className="form-subtitle">
                We will send you a One Time Password (OTP) to this mobile number
              </p>

              <div className="input-group">
                <span className="country-code">+91</span>
                <input
                  type="tel"
                  placeholder="Enter Mobile Number"
                  required
                  className="phone-input"
                  value={phoneNumber} // Bind phoneNumber to input field
                  onChange={(e) => setPhoneNumber(e.target.value.replace(/[^0-9]/g, ''))} // Update phone number state
                  onKeyDown={(e) => e.key === 'Enter' && handleGetOtpClick()} // Submit on Enter key
                />
              </div>

              {isLoading ? (
                  <div className="otp-overlay">
              <div className="otp-loader-box">
                <div className="otp-spinner"></div>
                <div className="otp-icon">
                  <IoMailOpenOutline />
                </div>
              </div>
            </div>
              ) : (
                <>
                <button
                  type="button" // Change to type="button" to avoid form submission
                  className="get-otp-button"
                  onClick={handleGetOtpClick} // Call the handler on click
                  disabled={isLoading}
                >
                  Get OTP
                </button>
                    {/* Registration Link */}
                  {/* <p className="register-text">
                    Don't have an account?{" "}
                    <Link to="/registration" className="register-link">
                      Register here
                    </Link>
                  </p> */}
                </>
              )}

            </form>
          </div>
        </div>
      )}

    </div>
  );
};

export default StaticLoginPage;